<template>
    <div class="about" id="about">
        <h1>About</h1>
        <h2>The intelligent City Concierge for smart City Travellers</h2>
        <div class="tabview">
            <ul>
                <li :class="selCount == 0 ? 'selected' : ''" @click="selCount = 0">Intuitive & Fancy Design</li>
                <li :class="selCount == 1 ? 'selected' : ''" @click="selCount = 1">Outstanding User Experience</li>
                <li :class="selCount == 2 ? 'selected' : ''" @click="selCount = 2">Comprehensive Payment</li>
                <li :class="selCount == 3 ? 'selected' : ''" @click="selCount = 3">Automatic VAT Refund</li>
            </ul>
            <Tab v-if="selCount == 0 || curWidth <= 780" name="Intuitive & Fancy Design" leftright=0 :curWidth="curWidth" :imgSrc="tabImageOne" desc="WIZY's state-of-the-art design provides for an outstanding user experience whilst your city trips. Most comprehensive information on local Sights, Restaurants and Shops, tailored according to your individual preferences, intuitive and easy to handle make big complexity feel super simple." :array="[]"/>
            <Tab v-if="selCount == 1 || curWidth <= 780" name="Outstanding User Experience" leftright=1 :curWidth="curWidth" :imgSrc="outstandingImage" desc="Thrilling Sights, top restaurants, the hottest bars and the latest in shopping, tailored exactly to your individual preferences, wherever you go, worldwide. This is the WIZY Travel Kit, your personal City Concierge who perfectly directs you whilst your travels and frees you from extensive travel preparations ahead." :array="[]"/>
            <Tab v-if="selCount == 2 || curWidth <= 780" name="Comprehensive Payment" leftright=0 :curWidth="curWidth" :imgSrc="comprehensive" desc="Store all your Bonus-, Loyalty- and Mileage-Cards in the WIZY Pocket and enjoy fully automatic reward recognition wherever you pay. Also, keep your sales receipts in the WIZY pocket, fully digitalized and available for automatic tax refund right away." :array="[]"/>
            <Tab v-if="selCount == 3 || curWidth <= 780" name="Automatic VAT Refund" leftright=1 :curWidth="curWidth" :imgSrc="vatRefund" desc="Enjoy most convenient Tap & Pay right from your Smartphone. Benefit from 36+ million acceptance points in more than 210 countries worldwide. Pay from your bank account, your Credit Card, PayPal and various additional sources - you decide by just ticking the respective option." :list="[]"/>
        </div>
    </div>
</template>


<script>
import Tab from '../components/Tab.vue'

export default {
  name: "About",
  components: {
      Tab
  },
  data(){
      return{
          selCount: 0,
          tabImageOne: require("@/assets/mockup-simplyfancy.png"),
          outstandingImage: require("@/assets/experience.png"),
          comprehensive: require("@/assets/comprehensive.png"),
          vatRefund: require("@/assets/registration.png"),
          curWidth: 0
      }
  },
  created(){
      window.addEventListener('resize',this.handleResize);
      this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.curWidth = window.innerWidth
    }
  }
};
</script>

<style lang="scss" scoped>
.about{
    margin-top: 5%;
    margin-bottom: 5%;
    text-align: center;
    h1{
        font-size: 2rem;
        font-weight: bold;
    }
    h2{
        color: rgb(107,115,122);
        padding: 1%;
        font-size: 1.1rem;
    }
    .tabview{
        ul{
            display: none;
            margin-bottom: 1%;
            @media(min-width: 780px){
                display: inherit;
                li{
                    display: inline-block;
                    padding: 1%;
                    font-weight: 500;
                    border-bottom: 1px solid lightgrey;
                    &.selected{
                        border-bottom: 2px solid rgb(100,161,211);
                    }
                    &:hover{
                        cursor: pointer;
                        transition: border 0.1s ease;
                        border-bottom: 2px solid rgb(100,161,211);
                    }
                    .underline{
                        border-bottom: 2px solid black;
                        width: 50px;
                        content: ''
                    }
                }
            }
        }
    }
}
</style>
